var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSleepInduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0001 10.7587C14.8297 11.666 13.3454 12.2085 11.7304 12.2085C7.95128 12.2085 4.88768 9.23792 4.88768 5.57351C4.88768 3.23671 6.13353 1.18207 8.01631 0C3.56784 0.121042 0 3.65571 0 7.9984C0 12.4176 3.69461 16 8.25214 16C11.8092 16 14.8406 13.8178 16.0001 10.7587Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepInduction);
export default __webpack_public_path__ + "static/media/sleep_induction.3eafb5dce171c242c2271c4f3beb85e7.svg";
export { ForwardRef as ReactComponent };